/* global jQuery */

export default class ColorInput {
  static selectorString() {
    return '.ColorInput';
  }

  render(node, props) {
    jQuery(node.querySelector('input')).minicolors();
  }
}
